module.exports = __webpack_public_path__ + "static/brotzeit-tablet-40e76842e43434feb82e92f028414934.jpg";